module.exports = __webpack_public_path__ + "img/snehal-pro.61575096.jpg";